import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const useMicEstatus = () => {

    const [estatusMic, setEstatusMic] = useState([]);
    const [estatusId, setEstatusId] = useState(0);
    const [dataEstatusSearch, setEstatusSearch] = useState([]);


    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const history = useHistory();
    const [loadingExport, setLoadingExport] = useState(false);

    const [formValues, handleInputChange, reset, handleUpdateValues,] = useForm({
        status: "",
    });
    const [validaciones, setValidaciones] = useState({
        name_valid: false,
    })
    const { status, } = formValues;

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(estatusMic.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listEstatus = [];
        estatusMic.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listEstatus.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setEstatusMic(listEstatus);
    }, [totalPageCount, currentPage])



    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };


    useEffect(() => {
        getEstatus();
    }, [history.location]);


    const getEstatus = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "Status/List");

        if (respuesta.code === 200) {
            let listEstatus = [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;

            if (respuesta.data.length >= 1) {
                respuesta.data.forEach((data, index) => {

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    listEstatus.push({
                        id_mic_status: data.id_mic_status,
                        status: data.status,
                        visibleTable: visibleTable
                    });
                });
                setEstatusMic(listEstatus);
                setEstatusSearch(listEstatus);
                setStatusData(listEstatus);
            }
        }
    }


    const handleCreate = () => {
        handleUpdateValues({
            status: "",
        });

        setEstatusId(0);
        setMethod("create");
        setModalTitle("Crear nuevo estatus");
        openDialog("Crear nuevo estatus", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Status");
        if (respuesta.code === 200) {
            getEstatus();
            createSweet("create", "success", "Éxito!", "Estatus creado con éxito");
            setLoading(false);
            closeDialog();
        }
    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.status === "" || formValues.status.length < 3) {
            newValidations = {
                ...newValidations,
                name_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                name_valid: false
            }
        }
        setValidaciones(newValidations);

        return statusValidation;
    }


    const [statusData, setStatusData] = useState([]);
    const [searchStatus, setSearchStatus] = useState("");

    const handleSearch = (e) => {
        setSearchStatus(e);

        let busqueda = e.toUpperCase();
        let newTypeSample = [];

        if (busqueda === "") {
            setEstatusMic([...statusData]);
        } else {
            estatusMic.forEach(element => {

                let cadena = element.status?.toUpperCase() || "";

                if (
                    cadena.indexOf(busqueda) > -1
                ) {
                    element.visibleTable = true;
                    newTypeSample.push(element);
                }
            });

            setEstatusMic([...newTypeSample]);
        }
    };

    const handleClear = () => {
        setSearchStatus("");                         
        localStorage.removeItem("globalFilter");    
        setEstatusMic(statusData);                    
    };


    const handleExportStatus = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

          const _report = estatusMic.map((item, index) => ({
                "#": index + 1,
                Estatus: item.status ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Estatus");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catálogo_estatus.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }
  
        setLoadingExport(false);
    };




    return {
        estatusMic, status, validaciones,
        method,
        handleInputChange, loading,
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        loadingExport, handleExportStatus, searchStatus, handleClear, handleSearch
    }

}




